import { render } from "./Index_affix_en_m.vue?vue&type=template&id=6ce53894"
import script from "./Index_affix_en_m.vue?vue&type=script&lang=js"
export * from "./Index_affix_en_m.vue?vue&type=script&lang=js"

import "./Index_affix_en_m.vue?vue&type=style&index=0&id=6ce53894&lang=css"
script.render = render

export default script